import React, { useContext, useEffect, useState } from 'react';
import { GlobalContext } from './GlobalContext';

type Props = {
    setValue: React.Dispatch<React.SetStateAction<string>>;
    condition: boolean;
    handleEnter: () => void;
};

export const useKeyboard = ({ setValue, condition, handleEnter }: Props) => {
    const { keyboardInput } = useContext(GlobalContext);
    const [count, setCount] = useState(0);

    useEffect(() => {
        setCount((prev) => prev + 1);
        if (condition && count > 0) {
            const input = keyboardInput[keyboardInput.length - 1];

            if (input === 'backspace')
                return setValue((prev) => prev.slice(0, -1));

            if (input === 'space') return setValue((prev) => `${prev} `);

            if (input === 'enter') return handleEnter();

            if (!input) return;

            setValue((prev) => `${prev}${input}`);
        }
    }, [keyboardInput]);
};
